<template>
  <ul :class="[size && `pagination-${size}`, align && `justify-content-${align}`]" class="pagination">
    <li v-if="showFirstPageButton" :class="{ disabled: value === 1 }" class="page-item first-page">
      <a aria-label="First" class="page-link" @click="firstPage">
        <span aria-hidden="true"><i aria-hidden="true" class="fa fa-angle-double-left"></i></span>
      </a>
    </li>
    <li :class="{ disabled: value === 1 }" class="page-item prev-page">
      <a aria-label="Previous" class="page-link" @click="prevPage">
        <span aria-hidden="true"><i aria-hidden="true" class="fa fa-angle-left"></i></span>
      </a>
    </li>
    <li v-for="item in range(minPage, maxPage)" :key="item" :class="{ active: value === item }" class="page-item">
      <a class="page-link" @click="changePage(item)">{{ item }}</a>
    </li>
    <li :class="{ disabled: value === totalPages }" class="page-item next-page">
      <a aria-label="Next" class="page-link" @click="nextPage">
        <span aria-hidden="true"><i aria-hidden="true" class="fa fa-angle-right"></i></span>
      </a>
    </li>
    <li v-if="showLastPageButton" :class="{ disabled: value === totalPages }" class="page-item last-page">
      <a aria-label="Last" class="page-link" @click="lastPage">
        <span aria-hidden="true"><i aria-hidden="true" class="fa fa-angle-double-right"></i></span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'BasePagination',
  props: {
    pageCount: {
      type: Number,
      default: 0,
      description: 'Pagination page count. This should be specified in combination with perPage',
    },

    perPage: {
      type: Number,
      default: 10,
      description: 'Pagination per page. Should be specified with total or pageCount',
    },

    total: {
      type: Number,
      default: 0,
      description: 'Can be specified instead of pageCount. The page count in this case will be total/perPage',
    },

    value: {
      type: Number,
      default: 1,
      description: 'Pagination value',
    },

    size: {
      type: String,
      default: '',
      description: 'Pagination size',
    },

    align: {
      type: String,
      default: '',
      description: 'Pagination alignment (e.g center|start|end)',
    },

    showFirstPageButton: {
      type: Boolean,
      default: false,
      description: 'Shows a button to go to the first page',
    },

    showLastPageButton: {
      type: Boolean,
      default: false,
      description: 'Shows a button to go to the last page',
    },
  },

  data() {
    return {
      defaultPagesToDisplay: 5,
    };
  },

  computed: {
    totalPages() {
      if (this.pageCount > 0) return this.pageCount;
      if (this.total > 0) {
        return Math.ceil(this.total / this.perPage);
      }
      return 1;
    },

    pagesToDisplay() {
      if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
        return this.totalPages;
      }
      return this.defaultPagesToDisplay;
    },

    minPage() {
      if (this.value >= this.pagesToDisplay) {
        const pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        const newMaxPage = pagesToAdd + this.value;
        if (newMaxPage > this.totalPages) {
          return this.totalPages - this.pagesToDisplay + 1;
        }
        return this.value - pagesToAdd;
      } else {
        return 1;
      }
    },

    maxPage() {
      if (this.value >= this.pagesToDisplay) {
        const pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        const newMaxPage = pagesToAdd + this.value;
        if (newMaxPage < this.totalPages) {
          return newMaxPage;
        } else {
          return this.totalPages;
        }
      } else {
        return this.pagesToDisplay;
      }
    },
  },

  watch: {
    perPage() {
      this.$emit('input', 1);
    },
    /* TODO deprecated - not working correctly
    total(newTotal, oldTotal) {
      if (oldTotal > 0 && newTotal > 0) {
        this.$emit("input", 1);
      }
    },*/
  },

  methods: {
    range(min, max) {
      let arr = [];
      for (let i = min; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    },

    changePage(item) {
      this.$emit('input', item);
    },

    nextPage() {
      if (this.value < this.totalPages) {
        this.$emit('input', this.value + 1);
      }
    },

    prevPage() {
      if (this.value > 1) {
        this.$emit('input', this.value - 1);
      }
    },

    firstPage() {
      if (this.value > 1) {
        this.$emit('input', 1);
      }
    },

    lastPage() {
      if (this.value < this.totalPages) {
        this.$emit('input', this.totalPages);
      }
    },
  },
};
</script>
